// Vendors
import React, { useCallback } from 'react'
import { useForm } from 'react-hook-form'

// Components
import { FieldTextArea } from 'components/FieldTextArea'

// Styles
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  Stack,
  Text,
} from '@chakra-ui/react'
import { useError } from 'hooks/useError'
import { apiPatch } from 'services/patch'
import { apiPost } from 'services/post'

type ModalRequestCollectionProps = {
  isOpen: boolean
  reload: () => void
  purchaseId: string
  onCancel: () => void
  activationCode: string
}

type FormRequestCollection = {
  comment: string
}

export const ModalRequestCollection = (props: ModalRequestCollectionProps) => {
  const { isOpen, reload, purchaseId, activationCode, onCancel } = props

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormRequestCollection>()

  const { handleError } = useError()

  const onClose = useCallback(() => {
    reset()
    onCancel()
  }, [onCancel, reset])

  const onSubmit = useCallback(
    async (data: FormRequestCollection) => {
      try {
        // TODO: Add your logic here
        await apiPost(`/app/purchase/${purchaseId}/request_recollect`, {
          comments: data.comment,
          activationCode: activationCode,
        })
        reload()
        onClose()
      } catch (error) {
        handleError(error)
      }
    },
    [activationCode, handleError, onClose, purchaseId, reload]
  )

  // TODO: Add your logic here
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent as="form" onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader>Solicitar recoleta</ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <Text color="gray.500" mb="4">
            Para prosseguir, por favor preencha os campos abaixo:
          </Text>

          <Stack>
            <FieldTextArea
              label="Justificativa"
              error={errors.comment}
              placeholder="Digite uma justificativa"
              {...register('comment', {
                required: 'Por favor, preencha o campo de justificativa',
              })}
            />
          </Stack>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <Button onClick={onClose}>Cancelar</Button>
            <Button type="submit" colorScheme="blue" isLoading={isSubmitting}>
              Confirmar
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
